module.exports = __webpack_public_path__ + "img/water-quality_attached.c2a78aec.svg";